/**
 * CSS-variable-aware color palette for Recharts charts.
 *
 * Reads from the active theme (light/dark) at call time so charts
 * automatically adapt when the user toggles the theme.
 */

function getCSSVar(name: string): string {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim()
  return value ? `hsl(${value})` : ''
}

export interface ChartColors {
  primary: string
  secondary: string
  success: string
  warning: string
  danger: string
  info: string
  muted: string
}

export function getChartColors(): ChartColors {
  return {
    primary: getCSSVar('--primary') || 'hsl(217, 91%, 60%)',
    secondary: getCSSVar('--secondary') || 'hsl(217, 33%, 18%)',
    success: 'hsl(152, 69%, 41%)',
    warning: 'hsl(38, 92%, 50%)',
    danger: 'hsl(0, 84%, 60%)',
    info: 'hsl(199, 89%, 48%)',
    muted: getCSSVar('--muted-foreground') || 'hsl(215, 20%, 65%)',
  }
}

/**
 * Fixed palette of 6 distinguishable colors for multi-series charts.
 * Chosen to be readable in both light and dark mode.
 */
export const CHART_PALETTE = [
  'hsl(217, 91%, 60%)',   // blue
  'hsl(160, 84%, 39%)',   // emerald
  'hsl(38, 92%, 50%)',    // amber
  'hsl(347, 77%, 50%)',   // rose
  'hsl(262, 83%, 58%)',   // violet
  'hsl(189, 94%, 43%)',   // cyan
]
